import {
  DateRangePickerMui,
  DateRangeValuePiece,
} from 'common/components/Inputs/DateRangePickerMui/DateRangePickerMui.tsx';
import { isArray } from 'lodash';
import { DateRangeValidationError } from '@mui/x-date-pickers-pro';

type DateRangePickerProps = {
  value: [DateRangeValuePiece, DateRangeValuePiece];
  onError: (error: DateRangeValidationError) => void;
  onChange: (dateRangeValuePiece: [DateRangeValuePiece, DateRangeValuePiece]) => void;
};

export const DateRangePicker = ({ value, onChange, onError }: DateRangePickerProps) => {
  return (
    <DateRangePickerMui
      disableFuture={true}
      onChange={(value) => {
        const from = value && isArray(value) && value[0] ? value[0] : null;
        const to = value && isArray(value) && value[1] ? value[1] : null;
        onChange([from, to]);
      }}
      value={value}
      allowClearing={true}
      size={'large'}
      onError={onError}
    />
  );
};
